export enum EUserType {
  SUPER = "SUPER",
  BROKER = "BROKER",
  EMPLOYEE = "EMPLOYEE",
  EMPLOYER = "EMPLOYER",
}
